<main role="main" id="paper-submissions">
  <nav class="navbar navbar-light navbar-dark" style="background-color: #2e3f50">
    <div>
      <button type="button" class="btn btn-outline-white btn-sm mr-3" (click)="exit()">Back</button>
    </div>
    <a class="navbar-brand text-white">View Paper</a>
    <div class="d-flex">
      <a *ngIf="previousPaperId >= 0 && sourcePage != 'inbox'" role="button" [routerLink]="['../', previousPaperId]" queryParamsHandling="preserve" class="btn btn-icon-only text-white font-size-3"><i class="fas fa-arrow-alt-square-up btn-icon__inner"></i></a>
      <a *ngIf="nextPaperId >= 0 && sourcePage != 'inbox'" role="button" [routerLink]="['../', nextPaperId]" queryParamsHandling="preserve" class="btn btn-icon-only text-white ml-1 font-size-3"><i class="fas fa-arrow-alt-square-down btn-icon__inner"></i></a>
    </div>
  </nav>
  <nav *ngIf="initialized" class="navbar navbar-dark navbar-dark" style="border-bottom: 1px solid #cbd6e2">
    <div class="form-inline">
      <label class="mr-1 mb-0" for="inlineFormInputName2">Title:</label>
      <strong>
        <inline-edit [readOnly]="reviewMode" (updated)="propertyUpdated('title')" [(ngModel)]="paper.title"></inline-edit>
      </strong>
    </div>

    <div class="ml-auto" *ngIf="reviewMode">
      <span class="paperApprovalStatus" [ngClass]="paper.paperApprovalStatus.toString()">{{ paper.paperApprovalStatus }}</span>
    </div>
    <div class="ml-auto" *ngIf="!reviewMode">
      <span class="paperApprovalStatus mr-2" [ngClass]="paper.paperApprovalStatus.toString()">{{ paper.paperApprovalStatus }}</span>
      <button *ngIf="paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Accepted]" class="btn btn-sm btn-success ml-2" (click)="renotify()" [promiseBtn]="approvalComplete" type="button">
        <i class="fas fa-paper-plane"></i> Re-Notify
      </button>
      <button *ngIf="paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Submitted]" class="btn btn-sm btn-success mr-2" (click)="approve()" [promiseBtn]="approvalComplete" type="button">
        <i class="fas fa-check-circle"></i> Accept
      </button>
      <!-- <button *ngIf="paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Submitted]" class="btn btn-sm btn-danger" type="button" [promiseBtn]="approvalComplete" (click)="reject(true)"><i class="fas fa-times-circle"></i> Reject</button> -->

      <div *ngIf="paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Submitted]" class="btn-group">
        <button type="button" (click)="reject(true)" class="btn btn-sm btn-danger">
          <i class="fas fa-times-circle"></i> Reject
        </button>
        <button type="button" class="btn btn-sm btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false"></button>
        <div class="dropdown-menu">
          <a class="dropdown-item" href="javascript:void(0)" (click)="reject(false)">Reject no Email</a>
        </div>
      </div>
    </div>
  </nav>

  <page-load-header *ngIf="!initialized"></page-load-header>

  <div *ngIf="initialized" class="container-fluid bg-white container-separator main-container pl-0 pr-0">
    <div class="row flex-nowrap" style="height: 100%">
      <div class="col-md-4 col-12 page-content-tools-sidebar space-1 shadow-border pl-5 d-none d-md-block" style="overflow-y: scroll">
        <ng-container [ngTemplateOutlet]="summary"></ng-container>
      </div>
      <div class="col-md col-12 main pa-1 bg-light space-md-1 pr-5 right-container">
        <ul class="nav nav-tabs justify-content-between justify-content-md-start">
          <li class="nav-item d-block d-md-none">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 5 }" (click)="tab = 5"><i class="fas fa-tachometer"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 0 }" (click)="tab = 0"><i class="fas fa-history"></i>
              <span class="d-none d-md-inline"> Activity</span></a>
          </li>
          <li class="nav-item d-none d-md-block">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 1 }" (click)="tab = 1"><i class="fas fa-newspaper"></i><span class="d-none d-md-inline"> Abstracts</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 2 }" (click)="tab = 2"><i class="fas fa-comments"></i><span class="d-none d-md-inline"> Notes</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 3 }" (click)="tab = 3"><i class="fas fa-envelope"></i><span class="d-none d-md-inline"> Email</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{ active: tab == 4 }" (click)="tab = 4"><i class="far fa-ballot-check"></i><span class="d-none d-md-inline"> Reviews</span></a>
          </li>
        </ul>

        <div class="tab-content-container bg-white d-block d-md-none" *ngIf="tab == 5">
          <div class="white-box">
            <ng-container [ngTemplateOutlet]="summary"></ng-container>
          </div>
        </div>
        <div class="tab-content-container" *ngIf="tab == 0">
          <h5>Activity Feed</h5>

          <div *ngFor="let activity of paper.activities" class="white-box">
            <div class="note-header d-flex">
              <div class="mr-auto">
                <strong>{{ activity.summary }} </strong>
                <span *ngIf="!blindReview" class="note-author">by {{ activity.user.fullName }}</span>
              </div>
              <div class="date">{{ activity.createdDate | date: 'medium' }}</div>
            </div>
            <div class="note-body">
              <!-- {{ note.body }} -->
            </div>
          </div>
        </div>
        <div class="tab-content-container" *ngIf="tab == 1">
          <div class="d-flex mb-1">
            <h5>Overall Abstract</h5>
            <button class="ml-auto btn btn-admin-primary btn-xs" (click)="propertyUpdated('abstract')">Save Changes</button>
          </div>
          <ng-container [ngTemplateOutlet]="abstracts"></ng-container>
        </div>
        <div class="tab-content-container" *ngIf="tab == 2">
          <div class="row mb-2">
            <div class="col d-flex">
              <h5 class="my-auto">Notes</h5></div>
            <div class="col text-right">
              <button type="button" (click)="addNote()" class="btn btn-sm btn-admin-primary">
                <i class="fas fa-edit"></i> Add Note
              </button>
            </div>
          </div>
          <div class="row no-gutters no-candidates" style="min-height: 200px" *ngIf="!paper.notes || paper.notes.length == 0">
            <div class="col-sm-12 my-auto">
              <h1><i class="fas fa-empty-set"></i>
              </h1>
              <h4>No Notes</h4>
              <p>No notes have been entered yet for this paper.</p>
            </div>
          </div>
          <div *ngFor="let note of paper.notes" class="white-box">
            <div class="note-header d-flex">
              <div class="mr-auto">
                <strong>Note </strong>
                <span class="note-author">by {{ note.author.fullName }}</span>
              </div>
              <div class="date">{{ note.createdDate | date: 'medium' }}</div>
            </div>
            <div class="note-body">
              {{ note.body }}
            </div>
            <div class="note-comments">
              <a class="text-admin-primary" (click)="note.commentsExpanded = !note.commentsExpanded" href="javascript:void(0)">
                <span *ngIf="note.comments.length == 0 && !note.commentsExpanded"> <i class="fas fa-comments"></i> Comments </span>
                <span *ngIf="note.comments.length > 0 && !note.commentsExpanded"> <i class="fas fa-comments"></i> {{ note.comments.length }} Comment(s) </span>
                <span *ngIf="note.commentsExpanded"> <i class="fas fa-comments"></i> Hide Comments </span>
              </a>
              <ng-container *ngIf="note.commentsExpanded">
                <div class="note-comment" *ngFor="let comment of note.comments">
                  <div class="comment-author">
                    <img class="img-fluid rounded-circle" style="width: 35px;" [fallback]="'fetch-avatar?userId=' + comment.author.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ comment.author.id }}-avatar.png"/> {{ comment.author.fullName }}
                  </div>
                  <div class="comment-body">{{ comment.body }}</div>
                </div>
                <div class="note-comment">
                  <div class="comment-author">
                    <img class="img-fluid rounded-circle" src="fetch-avatar?userId=1&width=32&height=32&mode=Crop"/> Chris Kooken
                  </div>
                  <div class="comment-body">
                    <textarea [mention]="items" [mentionConfig]="{ disableSearch: true }" (searchTerm)="searchTerm($event)" [(ngModel)]="note.newCommentEntry" name="noteEntry" placeholder="Send your colleage a notification by typing @ followed by their name. Only users in your organization can see comments."></textarea>
                  </div>
                  <button type="button" [disabled]="!note.newCommentEntry" (click)="addComment(note)" class="comment-button btn btn-admin-primary btn-xs">Save</button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="tab-content-container" *ngIf="tab == 3">
          <div class="row mb-2">
            <div class="col d-flex">
              <h5 class="my-auto">Emails</h5>
            </div>
            <div class="col text-right">
              <button type="button" (click)="addEmail()" class="btn btn-sm btn-admin-primary">
                <i class="fas fa-envelope"></i> New Email
              </button>
            </div>
          </div>
          <div class="row no-gutters no-candidates" style="min-height: 200px" *ngIf="!paper.emails || paper.emails.length == 0">
            <div class="col-sm-12 my-auto">
              <h1><i class="fas fa-empty-set"></i>
              </h1>
              <h4>No Emails</h4>
              <p>No emails have been sent or received yet for this paper.</p>
            </div>
          </div>
          <div *ngFor="let email of paper.emails" class="white-box">
            <div class="note-header d-flex">
              <div class="mr-auto">
                <div class="d-block">
                  <strong>Email - {{ email.subject }}</strong>
                  <span class="note-author"> from {{ email.from.fullName }}</span>
                </div>
                <div *ngIf="email.recipients && email.recipients.length > 0" class="d-block">
                  to
                  <span *ngFor="let recip of email.recipients">
                    <span *ngIf="recip.name">{{ recip.name }}</span>
                    <span *ngIf="!recip.name">{{ recip.emailAddress }}</span></span
                  >
                </div>
                <div *ngIf="!email.recipients || email.recipients.length == 0" class="d-block">to Review Team</div>
              </div>
              <div>
                <div class="date d-block">{{ email.createdDate | date: 'medium' }}</div>
                <div class="d-flex justify-content-between">
                  <a href="javascript:void(0)" class="mr-2" (click)="replyEmail(email)">Reply</a>
                  <a href="javascript:void(0)" class="mr-2" (click)="forwardEmail(email)">Forward</a><a class="mr-auto" href="javascript:void(0)">Delete</a>
                </div>
              </div>
            </div>
            <div class="note-body" [innerHTML]="email.body"></div>
            <div *ngIf="email.attachments && email.attachments.length > 0" class="email-attachments">
              <hr/>
              <div *ngFor="let attachment of email.attachments" class="attachment">
                <a href="/fetch-attchment?filename={{ attachment.azureBlobName }}&downloadName={{ attachment.filename }}&access_token={{ auth.getToken() }}">{{ attachment.filename }}</a> ({{ attachment.contentLength | bytes }})
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content-container" *ngIf="tab == 4">
          <ng-container *ngIf="paper.paperType.reviewCriteria && paper.paperType.reviewCriteria.length > 0">
            <div class="row mb-2">
              <div class="col">
                <h5>Reviews</h5>
              </div>

              <div class="col text-right"></div>
            </div>
            <div class="white-box">
              <div *ngFor="let criteria of paper.paperType.reviewCriteria; let idx = index" class="custom-control custom-switch mb-2">
                <input type="checkbox" class="custom-control-input admin-switch" (ngModelChange)="saveReviewCriteria(criteria.id, $event)" [(ngModel)]="criteria.result" name="criteriaMet" id="customSwitch{{ idx }}"/>
                <label class="custom-control-label" for="customSwitch{{ idx }}">{{ criteria.text }}</label>
              </div>
            </div>
          </ng-container>
          <div class="row mb-2">
            <div class="col">
              <h5>My Review</h5>
            </div>

            <div class="col text-right"></div>
          </div>
          <div *ngIf="currentUserHasReview && !editingReview" class="white-box text-center">
            <h4>Your review has been submitted!</h4>
            <h5>Score: {{ currentUserReview.score }}</h5>
            <a href="javascript:void(0)" (click)="editingReview = true">Edit Review</a>
          </div>
          <div *ngIf="!currentUserHasReview || editingReview" class="white-box">
            <div class="d-flex">
              <h5 class="my-auto" style="white-space: nowrap">Paper Rating</h5>

              <div class="flex-grow-1 text-right d-none d-md-block">
                <button type="button" (click)="reviewScore = 0" class="btn btn-sm btn-secondary mr-1" [ngClass]="{ 'btn-primary': reviewScore == 0, 'btn-secondary': reviewScore != 0 }">0 - Disapprove</button>
                <button type="button" (click)="reviewScore = 1" class="btn btn-sm btn-secondary mr-1" [ngClass]="{ 'btn-primary': reviewScore == 1, 'btn-secondary': reviewScore != 1 }">1 - Neutral</button>
                <button type="button" (click)="reviewScore = 2" class="btn btn-sm btn-secondary mr-1" [ngClass]="{ 'btn-primary': reviewScore == 2, 'btn-secondary': reviewScore != 2 }">2 - Approve</button>
                <button type="button" (click)="reviewScore = 3" class="btn btn-sm btn-secondary mr-1" [ngClass]="{ 'btn-primary': reviewScore == 3, 'btn-secondary': reviewScore != 3 }">3 - Strongly Approve</button>
              </div>
            </div>
            <div>
              <div class="btn-group mr-2 mt-2 w-100 d-block d-md-none" role="group" aria-label="First group">
                <button style="width: 25%" type="button" (click)="reviewScore = 0" class="btn btn-secondary" [ngClass]="{ 'btn-primary': reviewScore == 0, 'btn-secondary': reviewScore != 0 }">0</button>
                <button style="width: 25%" type="button" (click)="reviewScore = 1" class="btn btn-secondary" [ngClass]="{ 'btn-primary': reviewScore == 1, 'btn-secondary': reviewScore != 1 }">1</button>
                <button style="width: 25%" type="button" (click)="reviewScore = 2" class="btn btn-secondary" [ngClass]="{ 'btn-primary': reviewScore == 2, 'btn-secondary': reviewScore != 2 }">2</button>
                <button style="width: 25%" type="button" (click)="reviewScore = 3" class="btn btn-secondary" [ngClass]="{ 'btn-primary': reviewScore == 3, 'btn-secondary': reviewScore != 3 }">3</button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <h6>Internal Feedback
                  <span class="text-muted font-size-1">(Hidden from Submitter)</span>
                </h6>
              </div>
              <div class="col-md-12">
                <textarea [(ngModel)]="reviewFeedback" name="reviewFeedback" class="feedback-text"></textarea>
              </div>
              <div class="col-md-12">
                <div *ngIf="reviewError" class="text-danger">{{ reviewError }}</div>
                <button type="button" (click)="submitReview()" [promiseBtn]="submitReviewComplete" class="btn btn-sm btn-admin-primary">Submit Review</button>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!reviewMode || currentUserHasReview">
            <div class="row mb-2">
              <div class="col-md-6">
                <h5>All Reviews</h5>
              </div>
              <div class="col-md-6 text-right">
                <h5>Avg Score: {{ averageReview | number: '1.2-2' }}</h5>
              </div>

              <div class="col text-right"></div>
            </div>
            <div *ngFor="let review of paper.reviews" class="white-box">
              <div class="note-header d-flex">
                <div class="mr-auto">
                  <strong>Review </strong>
                  <span class="note-author mr-2">by {{ review.user.fullName }}</span>
                  <strong>Score: {{ review.score | number: '1.2-2' }}</strong>
                </div>
                <div class="date">{{ review.createdDate | date: 'medium' }}</div>
              </div>
              <div class="note-body">
                {{ review.feedback }}
              </div>
            </div>
            <!-- <h4>{{ review.user.fullName }}</h4>
              <h5>Score: {{ review.score }}</h5>
            </div> -->
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</main>
<ng-template #instructor let-instructor="instructor">
  <ng-container *ngIf="!instructor">
   <div> <strong>None</strong></div>
  </ng-container>
  <ng-container *ngIf="!blindReview && instructor">
    <div>
      <img class="img-fluid rounded-circle mr-1" style="width: 32px; height: 32px" [fallback]="'fetch-avatar?userId=' + instructor?.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ instructor?.id }}-avatar.png"/>{{ instructor?.fullName }}
      <a class="small" href="javascript:void(0)" (click)="viewBio(instructor)">(View Bio)</a>
    </div>
    <div>
      <label>Affiliation:</label> {{ instructor?.affiliation }}
    </div>
    <div>
      <label>Credentials:</label> {{ instructor?.credentials }}
    </div>
    <div>
      <label>Title:</label> {{ instructor?.organizationalTitle }}
    </div>
  </ng-container>
  <ng-container *ngIf="blindReview && instructor">
    <div>
      <i>Presenter Redacted for Blind Review</i>
    </div>
  </ng-container>
</ng-template>
<ng-template #abstracts>
  <ckeditor class="mb-1" (blur)="propertyUpdated('abstract')" [editor]="Editor" [config]="htmlEditorConfig" [(ngModel)]="paper.abstract" name="body" (ready)="onReady($event)" style="width: 100%"></ckeditor>

  <div *ngIf="paper.authors && paper.authors.length > 0" class="white-box-responsive mt-1">
    <div  class="d-block">
      <hr class="mt-2 mb-2"/>
      <ng-container *ngIf="!blindReview">
        <small class="mr-1"><strong>Authors:</strong></small>
        <small class="mr-2" *ngFor="let author of paper.authors">{{ author.fullNameWithCredentials }}</small>
      </ng-container>
      <ng-container *ngIf="blindReview">
        <div>
          <i>Authors Redacted for Blind Review</i>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngFor="let child of paper.childPapers; let idx = index">
    <div class="summary-section-title mt-3">Symposia Paper {{ idx + 1 }}</div>
    <div class="white-box-responsive">
      <div class="d-block">
        <strong>Title: </strong>
        <i>{{ child.title }}</i>
      </div>
      <div class="d-block mt-2">{{ child.description }}</div>
      <hr class="mt-2 mb-2"/>
      <div *ngIf="!blindReview" class="d-block">
        <small>{{ child.presenter.fullNameWithCredentials }}</small>
        <ng-container *ngIf="child.authors && child.authors.length > 0">
          <small class="mr-1 ml-2"><strong>Authors:</strong></small>
          <small class="mr-2" *ngFor="let author of child.authors">{{ author.fullNameWithCredentials }}</small>
        </ng-container>
      </div>
      <div *ngIf="blindReview" class="d-block">
        <div>
          <i>Authors Redacted for Blind Review</i>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-template #summary>
  <h4 class="m-0">{{ paper.paperTypeName }}</h4>
  <small class="d-block"
  >Status: <strong>
    <inline-edit style="display: inline-block" [readOnly]="reviewMode" type="select" [valuePrimitive]="true" [items]="paperStatuses" (updated)="propertyUpdated('paperApprovalStatus')" [(ngModel)]="paper.paperApprovalStatus"></inline-edit>
  </strong
  ></small>
  <small class="d-block"
  >Submitted by:
    <span *ngIf="!blindReview">{{ paper.submittingUser.fullName }}</span
    ><span *ngIf="blindReview"><i>Submitter Redacted for Blind Review</i></span></small
  >
  <small *ngIf="!blindReview" class="d-block">{{ paper.submittingUser.email }}</small>
  <!-- <div class="summary mt-2">
      <div class="summary-item">
        <label class="d-flex justify-content-between">
          <span>Assignee</span>
          <span><a href="javascript:void(0)" (click)="takeIt()">take it</a></span>
        </label>
        <div>
          <select class="form-control sm w-100" [compareWith]="compareFn" (ngModelChange)="updateAssignment($event)" [(ngModel)]="paper.assignedTo">
            <option *ngFor="let user of assignees" [ngValue]="user">{{ user.firstName }} {{ user.lastName }}</option>
          </select>
        </div>
      </div>
    </div> -->
  <div *ngIf="!reviewMode" class="summary user-multi-select mt-2">
    <div class="summary-item">
      <label class="">
        <span class="d-block">Reviewers</span>
        <span class="d-block text-danger small">Note: Reviewers will be notified as soon as you select them.</span>
      </label>
      <div>
        <kendo-multiselect [(ngModel)]="paper.reviewers" (ngModelChange)="updateReviewers($event)" name="reviewers" [popupSettings]="{ popupClass: 'email-search-popup' }" [valueNormalizer]="valueNormalizer" [filterable]="false" (filterChange)="handleFilter($event)" [data]="reviewerData | async" [loading]="userLoading" [valuePrimitive]="false" textField="fullName" valueField="id" [placeholder]="'Click here to choose'" [allowCustom]="false">
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div class="d-flex">
              <img style="width: 30px; height: 30px" class="rounded-circle" src="/fetch-avatar?userId={{ dataItem.id }}&width=30&height=30&mode=crop"/>
              <div class="ml-1 flex-grow" style="padding-top: 0.2rem">
                <div class="d-block">{{ dataItem.lastName }} {{ dataItem.firstName }} ({{ dataItem.email }})</div>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      </div>
    </div>
  </div>

  <div class="summary">
    <div class="summary-item user-multi-select">
      <label>Tags</label>
      <kendo-multiselect [(ngModel)]="paper.tags" (ngModelChange)="updateTags($event)" name="tags" [data]="tags" [popupSettings]="{ popupClass: 'email-search-popup' }" [valuePrimitive]="false" textField="label" [valueNormalizer]="tagValueNormalizer" valueField="id" [placeholder]="'Enter or choose existing'" [allowCustom]="true"></kendo-multiselect>
    </div>

    <hr/>
    <div class="summary-section-title">
      <i class="fas fa-info-circle"></i>General Information
    </div>
    <div *ngIf="paper.paperType.askForShortTitle" class="summary-item">
      <label>Short Title</label>
      <inline-edit [readOnly]="reviewMode" (updated)="propertyUpdated('shortTitle')" [(ngModel)]="paper.shortTitle"></inline-edit>
    </div>
    <div *ngIf="paper.paperType.askForContentArea" class="summary-item">
      <label>Content Area</label>
      <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="contentAreas" (updated)="propertyUpdated('contentArea')" [(ngModel)]="paper.contentArea"></inline-edit>
    </div>
    <div *ngIf="paper.paperType.askForCustomContentArea" class="summary-item">
      <label>Categories</label>
      <div *ngFor="let area of paper.customContentAreas">
        {{ area }}
      </div>
    </div>
    <div *ngIf="paper.paperType.askDuration" class="summary-item">
      <label>Desired Duration</label>
      <inline-edit [readOnly]="reviewMode" type="select" [valuePrimitive]="true" [items]="paper.paperType.availibleDurations" (updated)="propertyUpdated('anticipatedDurationMins')" [(ngModel)]="paper.anticipatedDurationMins">
        <ng-template let-item> {{ item }} Minutes</ng-template>
      </inline-edit>

      <!-- <div>{{ paper.anticipatedDurationMins }} <span *ngIf="paper.anticipatedDurationMins">minutes</span></div> -->
    </div>
    <div *ngIf="paper.paperType.askForChair" class="summary-item">
      <label>Chair</label>
      <ng-container [ngTemplateOutlet]="instructor" [ngTemplateOutletContext]="{ instructor: paper.chair }"></ng-container>
    </div>
    <div *ngIf="paper.paperType.askForDiscussant" class="summary-item">
      <label>Discussant</label>
      <ng-container [ngTemplateOutlet]="instructor" [ngTemplateOutletContext]="{ instructor: paper.discussant }"></ng-container>
    </div>
    <ng-container *ngIf="paper.paperType.askForPanelists">
      <div *ngFor="let panelist of paper.panelists; let idx = index" class="summary-item">
        <label>Panelist {{ idx + 1 }}
          <a href="javascript:void(0)" class="small" (click)="removePresenter('Panelist', panelist.id)">(remove)</a></label>
        <ng-container [ngTemplateOutlet]="instructor" [ngTemplateOutletContext]="{ instructor: panelist }"></ng-container>
      </div>
      <a class="small" href="javascript:void()" (click)="addPresenter('Presenter')">Add Panelist</a>
    </ng-container>
    <ng-container *ngIf="paper.paperType.askForPrimarySpeaker">
      <div *ngFor="let presenter of paper.presenters; let idx = index" class="summary-item">
        <label>Presenter {{ idx + 1 }}
          <a href="javascript:void(0)" class="small" (click)="removePresenter('Presenter', presenter.id)">(remove)</a></label>
        <ng-container [ngTemplateOutlet]="instructor" [ngTemplateOutletContext]="{ instructor: presenter }"></ng-container>
      </div>
      <a class="small" href="javascript:void()" (click)="addPresenter('Presenter')">Add Presenter</a>
    </ng-container>
    <hr/>
    <ng-container *ngIf="paper.paperType.customQuestionSurveyId">
      <div class="summary-section-title">
        <i class="fas fa-question-circle"></i>Custom Questions
      </div>

      <div class="summary-item" *ngFor="let question of customSurveyData; let idx = index">
        <label>{{ question.questionText }}</label>
        <div *ngIf="question.reponses">{{ question.reponses }}</div>
        <div *ngFor="let file of question.fileInfo"><a href="javascript:void(0)" (click)="downloadFile(file)">{{file.name}}</a></div>
        <div *ngIf="!question.reponses && question.fileInfo.length ==0">-- No Value --</div>
      </div>
      <div class="summary-item" *ngIf="paper.paperType.askForSpecialRequests">
        <label>Special Requests</label>
        <inline-edit [readOnly]="reviewMode" (updated)="propertyUpdated('specialRequests')" [(ngModel)]="paper.specialRequests"></inline-edit>
      </div>
      <hr/>
    </ng-container>
    <div class="d-block d-md-none mb-2">
      <div class="summary-section-title">Abstract</div>

      <ng-container [ngTemplateOutlet]="abstracts"></ng-container>
      <hr/>
    </div>
    <ng-container *ngIf="paper.paperType.askForCEUInfo || paper.paperType.askForLearningObjectives">
      <div class="summary-section-title">
        <i class="fad fa-certificate"></i>CEU Information
      </div>
      <div *ngIf="paper.paperType.askForLearningObjectives" class="summary-item">
        <label>Learning Objective 1</label>
        <inline-edit [wrap]="true" [readOnly]="reviewMode" (updated)="propertyUpdated('learningObjective1')" [(ngModel)]="paper.learningObjective1"></inline-edit>
      </div>
      <div *ngIf="paper.paperType.askForLearningObjectives" class="summary-item">
        <label>Learning Objective 2</label>
        <inline-edit [wrap]="true" [readOnly]="reviewMode" (updated)="propertyUpdated('learningObjective2')" [(ngModel)]="paper.learningObjective2"></inline-edit>
      </div>
      <div *ngIf="paper.paperType.askForLearningObjectives" class="summary-item">
        <label>Learning Objective 3</label>
        <inline-edit [wrap]="true" [readOnly]="reviewMode" (updated)="propertyUpdated('learningObjective3')" [(ngModel)]="paper.learningObjective3"></inline-edit>
      </div>
      <div *ngIf="paper.paperType.askForAPACEUInfo" class="summary-item">
        <label>Meets APA Requirements</label>
        <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="yesNoUnsure" (updated)="propertyUpdated('meetsAPACEURequirements')" [(ngModel)]="paper.meetsAPACEURequirements"></inline-edit>
      </div>
      <div class="summary-item">
        <label>Meets BACB Requirements</label>
        <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="yesNoUnsure" (updated)="propertyUpdated('meetsCEURequirements')" [(ngModel)]="paper.meetsCEURequirements"></inline-edit>
      </div>
      <div class="summary-item">
        <label>Meets Ethics Requirements</label>
        <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="yesNoUnsure" (updated)="propertyUpdated('meetsEthicsCEURequirements')" [(ngModel)]="paper.meetsEthicsCEURequirements"></inline-edit>
      </div>
      <div class="summary-item">
        <label>Meets Supervision Requirements</label>
        <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="yesNoUnsure" (updated)="propertyUpdated('meetsSupervisionCEURequirements')" [(ngModel)]="paper.meetsSupervisionCEURequirements"></inline-edit>
      </div>
      <div class="summary-item">
        <label>CEU Instructor</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('ceuInstructorName')" [(ngModel)]="paper.ceuInstructorName"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>CEU Instructor Cert #</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('ceuInstructorBACBNumber')" [(ngModel)]="paper.ceuInstructorBACBNumber"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>CEU Instructor CV</label>
        <div *ngIf="!blindReview">
          <a *ngIf="paper.cvAssetPath && paper.cvAssetPath.length > 0" href="/fetch-cv?filename={{ paper.cvAssetPath | encodeUrl }}&downloadName={{ paper.cvAssetPath.slice(36) }}">{{ paper.cvAssetPath.slice(36) }}</a>
          <span *ngIf="!paper.cvAssetPath || paper.cvAssetPath.length == 0">Missing</span>
        </div>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
    </ng-container>
    <ng-container>
      <div class="summary-item">
        <label>Has Supporting Data</label>
        <inline-edit [readOnly]="reviewMode" type="select" [textField]="'name'" [valueField]="'value'" [items]="yesNo" (updated)="propertyUpdated('hasSupportingData')" [(ngModel)]="paper.hasSupportingData"></inline-edit>
      </div>
      <div *ngIf="!paper.hasSupportingData" class="summary-item">
        <label>Reason for no Data</label>
        <inline-edit [readOnly]="reviewMode" (updated)="propertyUpdated('dataNullReason')" [(ngModel)]="paper.dataNullReason"></inline-edit>
      </div>
      <div *ngIf="paper.hasSupportingData" class="summary-item">
        <label>Supporting Data</label>
        <div>
          <a *ngIf="paper.dataAssetPath && paper.dataAssetPath.length > 0" href="/fetch-cv?filename={{ paper.dataAssetPath | encodeUrl }}&downloadName={{ paper.dataAssetPath.slice(36) }}">{{ paper.dataAssetPath.slice(36) }}</a>
          <span *ngIf="!paper.dataAssetPath || paper.dataAssetPath.length == 0">Missing</span>
        </div>
      </div>
    </ng-container>
    <hr/>

    <ng-container *ngIf="paper.paperType.askForPaymentInfo">
      <div class="summary-section-title">
        <i class="far fa-money-check"></i>Payment Information
      </div>
      <div class="summary-item">
        <label>Payment Name</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('checkName')" [(ngModel)]="paper.checkName"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>Address</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('address1')" [(ngModel)]="paper.address1"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>Address2</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('address2')" [(ngModel)]="paper.address2"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>City</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('city')" [(ngModel)]="paper.city"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>State</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('state')" [(ngModel)]="paper.state"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
      <div class="summary-item">
        <label>Postal Code</label>
        <inline-edit *ngIf="!blindReview" [readOnly]="reviewMode" (updated)="propertyUpdated('zip')" [(ngModel)]="paper.zip"></inline-edit>
        <div *ngIf="blindReview">
          <i>Redacted for Blind Review</i></div>
      </div>
    </ng-container>

    <div  class="summary-item">
      <label>Special Requests</label>
      <inline-edit [wrap]="true" [readOnly]="reviewMode" (updated)="propertyUpdated('specialRequests')" [(ngModel)]="paper.specialRequests"></inline-edit>
    </div>
    <div class="mb-6"></div>
    <div class="mb-6"></div>
  </div>
</ng-template>
